import LegalPage from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      seoDescription="How StUpEco Workspace collects, uses and protects your personal information on our website."
      path="/privacy"
      updated="December 2025"
      intro="Your privacy matters to us. This policy explains what information we collect through the StUpEco Workspace website, how we use it, and the choices you have."
      sections={[
        {
          heading: "1. Information we collect",
          body: [
            "We collect information you provide directly to us, such as when you create an account, contact us, subscribe to updates, or join a waitlist.",
            [
              "Account details: your name, email address and password (stored securely and hashed).",
              "Form submissions: contact messages, newsletter and pricing-notification sign-ups, including consent, the page you submitted from, and a timestamp.",
              "Marketing attribution: UTM parameters where present in the link you arrived through.",
              "Technical data: basic, privacy-respecting information needed to operate and secure the site.",
            ],
          ],
        },
        {
          heading: "2. How we use your information",
          body: [
            "We use the information we collect to operate, maintain and improve our website and to communicate with you.",
            [
              "To create and manage your account and keep you signed in.",
              "To respond to enquiries you send through the contact form.",
              "To send you the updates you opted into (newsletter, pricing launch notifications).",
              "To understand which content is useful and to improve the experience.",
            ],
          ],
        },
        {
          heading: "3. Consent",
          body: [
            "We only add you to marketing lists when you explicitly opt in. Every form that collects your email records your consent and the source page. You can withdraw consent at any time by contacting us.",
          ],
        },
        {
          heading: "4. How we protect your data",
          body: [
            "We apply appropriate technical and organisational measures to protect your information. Traffic is encrypted in transit, passwords are hashed, and access is limited to what is necessary to operate the service.",
          ],
        },
        {
          heading: "5. Sharing your information",
          body: [
            "We do not sell your personal information. We may share limited data with trusted service providers who help us operate the site (for example, to send transactional emails), under appropriate confidentiality obligations.",
          ],
        },
        {
          heading: "6. Your rights",
          body: [
            "Depending on your location, you may have rights to access, correct, export or delete your personal information, and to object to certain processing. To exercise these rights, contact us and we will respond within a reasonable timeframe.",
          ],
        },
        {
          heading: "7. Changes to this policy",
          body: [
            "We may update this policy as the product evolves through its phases. Material changes will be reflected by updating the date at the top of this page.",
          ],
        },
      ]}
    />
  );
}
